import { AppState } from '../../client-redux/reducers';
import { NumberInput, Table } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Language } from '../../languages/languageHandler';
import { formatCurrAmount } from '../../utils/script';

interface ValuesTableProps {
  mc?: { index: number; quantity: number }[];
  onChange?: (mc: { index: number; quantity: number }[]) => void;
}

const ValuesTable = ({ mc = [], onChange }: ValuesTableProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);
  const currencies = useSelector((state: any) => state.currencies.currencies);
  const currency = currencies?.[0];

  const [rows, setRows] = useState<{ index: number; value: number; type: string; quantity: number }[]>([]);

  useEffect(() => {
    if (!currency) return;

    const mcMap = new Map(mc.map(m => [m.index, m]));

    const mapped = currency.denominations
      .filter((d: any) => {
        return d && d.value > 0 && (d.type === 1 || d.type === 2) && d.value >= 1;
      })
      .map((d: any) => {
        const mcItem = mcMap.get(d.index);

        return {
          index: d.index,
          value: formatCurrAmount(d.value, currency),
          type: d.type === 1 ? `${lang.GLOBAL_COIN}` : `${lang.GLOBAL_BILL}`,
          quantity: mcItem?.quantity ?? 0
        };
      });

    setRows(mapped);
  }, [currency, mc, lang]);

  const handleChange = (index: number, newValue: number) => {
    const intValue = Math.round(newValue);
    const updated = rows.map(r => (r.index === index ? { ...r, quantity: intValue } : r));

    setRows(updated);
    const newMc = updated
      .filter(r => r.quantity > 0)
      .map(r => ({
        index: r.index,
        quantity: r.quantity,
        origin: 0,
        destiny: 0
      }));

    onChange?.(newMc);
  };

  return (
    <Table className="values-table">
      <Table.Thead>
        <Table.Tr>
          <Table.Th>{lang.BRISA_WITHDRAW_SETS_AMOUNT}</Table.Th>
          <Table.Th>{lang.BRISA_WITHDRAW_SETS_TYPE}</Table.Th>
          <Table.Th>{lang.BRISA_WITHDRAW_SETS_QUANTITY}</Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {rows.map(row => (
          <Table.Tr key={row.index}>
            <Table.Td>{row.value}</Table.Td>
            <Table.Td>{row.type}</Table.Td>
            <Table.Td className="number-input">
              <NumberInput value={row.quantity} min={0} onChange={val => handleChange(row.index, Number(val) || 0)} />
            </Table.Td>
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};

export default ValuesTable;
